<template>
  <div class="canvas-cont">
    <canvas id="sprite"
      @mouseover="startRender"
      @mouseleave="destroy"
      v-if="!isMobile()"
    ></canvas>
    <canvas id="sprite-blue"
      @mouseover="startRender"
      @mouseleave="destroy"
      v-if="!isMobile()"
    ></canvas>
    <img class="image__logo" src="/static/img/logo/logo.svg" alt="Logo One world one face" v-if="isMobile()">
  </div>
</template>

<script>
import loop from 'raf-loop';

import { isMobile } from '@/scripts/utils';

export default {
  name: 'Logo',

  data() {
    return {
      isMobile,
      image: null,
    };
  },

  mounted() {
    if (!this.isMobile()) this.inizializeSprite();
  },

  methods: {
    inizializeSprite() {
      // Get canvas
      this.canvas = document.getElementById('sprite');
      this.canvas1 = document.getElementById('sprite-blue');

      this.index = 0;
      this.frameIndex = 0;
      this.tickCount = 0;

      this.ctx = this.canvas.getContext('2d');
      this.ctx1 = this.canvas1.getContext('2d');

      this.loop = loop(this.render.bind(this));
      this.ticksPerFrame = 0;
      this.numberOfFrames = 0;

      this.sprite = new Image();
      this.sprite.src = './static/img/logo/sprite-w.png';
      this.sprite1 = new Image();
      this.sprite1.src = './static/img/logo/sprite-b.png';

      this.image = new Image();
      this.image.src = './static/img/logo/single-img.png';

      this.image.onload = () => {
        this.setDim();
        this.render();
      };

      this.isAnimateIn = true;
      this.isAnimateOut = false;
    },

    setDim() {
      this.col = 15;
      this.line = 15;

      const w = this.sprite.width / this.col === 0 ? 128 : this.sprite.width / this.col;
      const h = this.sprite.height / this.line === 0 ? 126 : this.sprite.height / this.line;

      this.canvas.width = w;
      this.canvas.height = h;
      this.canvas1.width = w;
      this.canvas1.height = h;

      this.numberOfFrames = this.col * this.line;

      this.frameWidth = w;
      this.frameHeight = h;

      this.scale = this.sprite.width / (this.canvas.width * this.col);
    },

    startRender() {
      this.loop.start();
    },

    animateIn() {
      this.tickCount += 1;

      if (this.tickCount > this.ticksPerFrame) {
        this.tickCount = 0;

        // If the current frame index is in range
        if (this.frameIndex < this.numberOfFrames - 2) {
          this.frameIndex += 1;

          // Draw the animation
          this.sx = Math.floor(this.frameIndex % this.col) * this.frameWidth;
          this.sy = Math.floor(this.frameIndex / this.col) * this.frameHeight;

          // this.yPosition = (this.frameIndex * this.widths[this.index]) / this.numberOfFrames;
        } else {
          this.frameIndex = 0;
        }
      }
    },

    render() {
      if (this.isAnimateIn) {
        this.animateIn();
      } else if (this.isAnimateOut) {
        this.animateOut();
      }

      // // Clear the canvas
      this.ctx.clearRect(
        0,
        0,
        this.canvas.width,
        this.canvas.height,
      );

      this.ctx1.clearRect(
        0,
        0,
        this.canvas.width,
        this.canvas.height,
      );

      this.ctx.drawImage(
        this.sprite,
        this.sx,
        this.sy,
        this.frameWidth,
        this.frameHeight,
        0,
        0,
        this.frameWidth,
        this.frameHeight,
      );

      this.ctx1.drawImage(
        this.sprite1,
        this.sx,
        this.sy,
        this.frameWidth,
        this.frameHeight,
        0,
        0,
        this.frameWidth,
        this.frameHeight,
      );
    },

    destroy() {
      this.loop.stop();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.canvas-cont {
  position: relative;

  transform-origin: 0 50%;
  transform: scale(0.8);

  #sprite {
    opacity: 1;
    transition: opacity 0.3s ease;
  }

  #sprite-blue {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    #sprite {
      opacity: 0;
    }

    #sprite-blue {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue